/* eslint-disable react/prop-types */
import React, {
  lazy, memo, Suspense, useMemo,
} from 'react';

import { BACK_CARD_NAME } from '@ezugi/constants';

import { CARD_TYPES, CARD_SIZES } from './constants';

const CardRegular = lazy(() => import('./CardRegular'));
const CardSmall = lazy(() => import('./CardSmall'));

type CardProps = {
  name: string;
  value?: number | string;
  'data-e2e'?: string;
  type?: keyof typeof CARD_TYPES;
  [key: string]: any; // For any additional props
}

const CardComponent: React.FC<CardProps> = memo(
  ({ name, value = 0, 'data-e2e': dataE2e = 'card', type = CARD_TYPES.REGULAR, ...props }) => {
    const viewBox = useMemo(() => {
      const { WIDTH, HEIGHT } = CARD_SIZES[type];

      return `0 0 ${WIDTH} ${HEIGHT}`;
    }, [ type ]);

    const isRegular = type === CARD_TYPES.REGULAR;

    return (
      <svg
        viewBox={viewBox}
        data-e2e={dataE2e + (name === BACK_CARD_NAME ? '-covered' : '-revealed')}
        data-name={name}
        data-value={value}
        data-type={type}
        {...props}
      >
        <Suspense fallback={null}>
          {React.createElement(isRegular ? CardRegular : CardSmall, { name })}
        </Suspense>
      </svg>
    );
  }
);

const Card = CardComponent as React.FC<CardProps> & {
  WIDTH: number;
  HEIGHT: number;
  WIDTH_SMALL: number;
  HEIGHT_SMALL: number;
  CARD_SIZES: typeof CARD_SIZES;
  CARD_TYPES: typeof CARD_TYPES;
};

Card.WIDTH = CARD_SIZES[CARD_TYPES.REGULAR].WIDTH;
Card.HEIGHT = CARD_SIZES[CARD_TYPES.REGULAR].HEIGHT;
Card.WIDTH_SMALL = CARD_SIZES[CARD_TYPES.SMALL].WIDTH;
Card.HEIGHT_SMALL = CARD_SIZES[CARD_TYPES.SMALL].HEIGHT;

Card.CARD_SIZES = CARD_SIZES;
Card.CARD_TYPES = CARD_TYPES;

export default Card;
